import React from "react";
import { useSelector } from "react-redux";
import ReactVisibilitySensor from "react-visibility-sensor";
import { businessReviewIcons, paragraphImages } from "../assets/js/images";
import {
  getContent,
  getDelayedIndexBasedAnimationTime,
  getRightContent,
  getVisibleSensorAnimation,
} from "../assets/js/utils";
import Accordion from "./Accordion";
import ContentTitle from "./ContentTitle";
import CustomReadMore from "./CustomReadMore";
import CustomReadMoreTitle from "./CustomReadMoreTitle";
import useKeyPropRtlLanguage from "./hooks/useKeyPropRtlLanguage";
import useWindowSize from "./hooks/useWindowSize";
import Media from "./Media";
import ParagraphImage from "./ParagraphImage";
import SimpleMedia from "./SimpleMedia";

function Content8(props) {
  const generalSettings = useSelector((state) => state.ui.generalSettings);
  const sections = useSelector((state) => state.ui.sections);
  const keyAnimationRestartWhenChangeLanguage = useKeyPropRtlLanguage();
  const windowWidth = useWindowSize();
  return (
    <div key={keyAnimationRestartWhenChangeLanguage}>
      <div className="general-m">
        <ContentTitle
          label={getRightContent(
            generalSettings.rtlLanguage,
            getContent().sections[sections.currentSection].content.title
          )}
        />
        <div className="general-separator"></div>
        <Accordion
          items={[
            {
              title: getRightContent(
                generalSettings.rtlLanguage,
                getContent().sections[sections.currentSection].content
                  .accordionTitles
              )[0],
              content: (
                <div>
                  <p className="main-paragraph color-secondary">
                    {getRightContent(
                      generalSettings.rtlLanguage,
                      getContent().sections[sections.currentSection].content
                        .accordionContents[0].mainParagraph
                    )}
                  </p>
                  <div className="green-box">
                    {getContent().sections[
                      sections.currentSection
                    ].content.accordionContents[0].mediaItems.map(
                      (simpleMedia, index) => (
                        <ReactVisibilitySensor partialVisibility key={index}>
                          {({ isVisible }) => (
                            <div
                              className="green-box__item"
                              style={getVisibleSensorAnimation(
                                isVisible,
                                `fade-in-40px 1s ${getDelayedIndexBasedAnimationTime(
                                  windowWidth,
                                  index
                                )}s backwards`
                              )}
                            >
                              {
                                <Media
                                  icon={
                                    businessReviewIcons[0][
                                      simpleMedia.iconIndex
                                    ]
                                  }
                                  SimpleMediaComponent={
                                    <SimpleMedia
                                      counterValue={simpleMedia.counterValue}
                                      prefix={getRightContent(
                                        generalSettings.rtlLanguage,
                                        simpleMedia.prefix || ["", ""]
                                      )}
                                      suffix={getRightContent(
                                        generalSettings.rtlLanguage,
                                        simpleMedia.suffix || ["", ""]
                                      )}
                                      bottomText={getRightContent(
                                        generalSettings.rtlLanguage,
                                        simpleMedia.bottomText
                                      )}
                                    />
                                  }
                                />
                              }
                            </div>
                          )}
                        </ReactVisibilitySensor>
                      )
                    )}
                  </div>
                  <div className="general-separator"></div>
                  <ParagraphImage
                    image={paragraphImages[0]}
                    TextComponent={
                      <>
                        <CustomReadMore
                          text={getRightContent(
                            generalSettings.rtlLanguage,
                            getContent().sections[sections.currentSection]
                              .content.accordionContents[0].customReadMore1.text
                          )}
                          textComplement={getRightContent(
                            generalSettings.rtlLanguage,
                            getContent().sections[sections.currentSection]
                              .content.accordionContents[0].customReadMore1
                              .complement
                          )}
                          applyMainTextClassNameInIndex={{
                            classNames: ["color-primary"],
                            indexes: [0],
                          }}
                        />
                      </>
                    }
                  />
                  <div className="general-separator"></div>
                  <div className="general-separator"></div>
                  <ParagraphImage
                    imageFirst={true}
                    image={paragraphImages[1]}
                    TextComponent={
                      <>
                        <CustomReadMoreTitle
                          applyClassName="color-secondary"
                          title={getRightContent(
                            generalSettings.rtlLanguage,
                            getContent().sections[sections.currentSection]
                              .content.accordionContents[0]
                              .titleH2CustomReadMore2
                          )}
                        />
                        <CustomReadMore
                          text={getRightContent(
                            generalSettings.rtlLanguage,
                            getContent().sections[sections.currentSection]
                              .content.accordionContents[0].customReadMore2.text
                          )}
                          textComplement={getRightContent(
                            generalSettings.rtlLanguage,
                            getContent().sections[sections.currentSection]
                              .content.accordionContents[0].customReadMore2
                              .complement
                          )}
                        />
                      </>
                    }
                  />
                </div>
              ),
            },
            {
              title: getRightContent(
                generalSettings.rtlLanguage,
                getContent().sections[sections.currentSection].content
                  .accordionTitles
              )[1],
              content: (
                <div>
                  <div className="general-separator"></div>
                  <div className="green-box">
                    {getContent().sections[
                      sections.currentSection
                    ].content.accordionContents[1].mediaItems.map(
                      (simpleMedia, index) => (
                        <ReactVisibilitySensor partialVisibility key={index}>
                          {({ isVisible }) => (
                            <div
                              className="green-box__item"
                              style={getVisibleSensorAnimation(
                                isVisible,
                                `fade-in-40px 1s ${getDelayedIndexBasedAnimationTime(
                                  windowWidth,
                                  index
                                )}s backwards`
                              )}
                            >
                              {
                                <Media
                                  icon={
                                    businessReviewIcons[1][
                                      simpleMedia.iconIndex
                                    ]
                                  }
                                  SimpleMediaComponent={
                                    <SimpleMedia
                                      counterValue={simpleMedia.counterValue}
                                      prefix={getRightContent(
                                        generalSettings.rtlLanguage,
                                        simpleMedia.prefix || ["", ""]
                                      )}
                                      suffix={getRightContent(
                                        generalSettings.rtlLanguage,
                                        simpleMedia.suffix || ["", ""]
                                      )}
                                      bottomText={getRightContent(
                                        generalSettings.rtlLanguage,
                                        simpleMedia.bottomText
                                      )}
                                    />
                                  }
                                />
                              }
                            </div>
                          )}
                        </ReactVisibilitySensor>
                      )
                    )}
                  </div>
                  <div className="general-separator"></div>
                  <ParagraphImage
                    image={paragraphImages[2]}
                    TextComponent={
                      <>
                        <CustomReadMore
                          text={getRightContent(
                            generalSettings.rtlLanguage,
                            getContent().sections[sections.currentSection]
                              .content.accordionContents[1].customReadMore1.text
                          )}
                          textComplement={getRightContent(
                            generalSettings.rtlLanguage,
                            getContent().sections[sections.currentSection]
                              .content.accordionContents[1].customReadMore1
                              .complement
                          )}
                          applyMainTextClassNameInIndex={{
                            classNames: ["color-primary"],
                            indexes: [0],
                          }}
                        />
                      </>
                    }
                  />
                  <div className="general-separator"></div>
                  <div className="general-separator"></div>
                  <ParagraphImage
                    imageFirst={true}
                    image={paragraphImages[3]}
                    TextComponent={
                      <>
                        <CustomReadMoreTitle
                          applyClassName="color-secondary"
                          title={getRightContent(
                            generalSettings.rtlLanguage,
                            getContent().sections[sections.currentSection]
                              .content.accordionContents[1]
                              .titleH2CustomReadMore2
                          )}
                        />
                        <CustomReadMore
                          text={getRightContent(
                            generalSettings.rtlLanguage,
                            getContent().sections[sections.currentSection]
                              .content.accordionContents[1].customReadMore2.text
                          )}
                          textComplement={getRightContent(
                            generalSettings.rtlLanguage,
                            getContent().sections[sections.currentSection]
                              .content.accordionContents[1].customReadMore2
                              .complement
                          )}
                        />
                      </>
                    }
                  />
                </div>
              ),
            },
            {
              title: getRightContent(
                generalSettings.rtlLanguage,
                getContent().sections[sections.currentSection].content
                  .accordionTitles
              )[2],
              content: (
                <div>
                  <div className="general-separator"></div>
                  <div className="green-box">
                    {getContent().sections[
                      sections.currentSection
                    ].content.accordionContents[2].mediaItems.map(
                      (simpleMedia, index) => (
                        <ReactVisibilitySensor partialVisibility key={index}>
                          {({ isVisible }) => (
                            <div
                              className="green-box__item"
                              style={getVisibleSensorAnimation(
                                isVisible,
                                `fade-in-40px 1s ${getDelayedIndexBasedAnimationTime(
                                  windowWidth,
                                  index
                                )}s backwards`
                              )}
                            >
                              {
                                <Media
                                  icon={
                                    businessReviewIcons[2][
                                      simpleMedia.iconIndex
                                    ]
                                  }
                                  SimpleMediaComponent={
                                    <SimpleMedia
                                      counterValue={simpleMedia.counterValue}
                                      prefix={getRightContent(
                                        generalSettings.rtlLanguage,
                                        simpleMedia.prefix || ["", ""]
                                      )}
                                      suffix={getRightContent(
                                        generalSettings.rtlLanguage,
                                        simpleMedia.suffix || ["", ""]
                                      )}
                                      bottomText={getRightContent(
                                        generalSettings.rtlLanguage,
                                        simpleMedia.bottomText
                                      )}
                                    />
                                  }
                                />
                              }
                            </div>
                          )}
                        </ReactVisibilitySensor>
                      )
                    )}
                  </div>
                  <div className="general-separator"></div>
                  <ParagraphImage
                    image={paragraphImages[4]}
                    TextComponent={
                      <>
                        <CustomReadMore
                          text={getRightContent(
                            generalSettings.rtlLanguage,
                            getContent().sections[sections.currentSection]
                              .content.accordionContents[2].customReadMore1.text
                          )}
                          textComplement={getRightContent(
                            generalSettings.rtlLanguage,
                            getContent().sections[sections.currentSection]
                              .content.accordionContents[2].customReadMore1
                              .complement
                          )}
                          applyMainTextClassNameInIndex={{
                            classNames: ["color-primary"],
                            indexes: [0],
                          }}
                        />
                      </>
                    }
                  />
                  <div className="general-separator"></div>
                  <div className="general-separator"></div>
                  <ParagraphImage
                    imageFirst={true}
                    image={paragraphImages[5]}
                    TextComponent={
                      <>
                        <CustomReadMoreTitle
                          applyClassName="color-secondary"
                          title={getRightContent(
                            generalSettings.rtlLanguage,
                            getContent().sections[sections.currentSection]
                              .content.accordionContents[2]
                              .titleH2CustomReadMore2
                          )}
                        />
                        <CustomReadMore
                          text={getRightContent(
                            generalSettings.rtlLanguage,
                            getContent().sections[sections.currentSection]
                              .content.accordionContents[2].customReadMore2.text
                          )}
                          textComplement={getRightContent(
                            generalSettings.rtlLanguage,
                            getContent().sections[sections.currentSection]
                              .content.accordionContents[2].customReadMore2
                              .complement
                          )}
                        />
                      </>
                    }
                  />
                </div>
              ),
            },
            {
              title: getRightContent(
                generalSettings.rtlLanguage,
                getContent().sections[sections.currentSection].content
                  .accordionTitles
              )[3],
              content: (
                <div>
                  <p className="main-paragraph color-secondary">
                    {getRightContent(
                      generalSettings.rtlLanguage,
                      getContent().sections[sections.currentSection].content
                        .accordionContents[3].mainParagraph
                    )}
                  </p>
                  <div className="green-box">
                    {getContent().sections[
                      sections.currentSection
                    ].content.accordionContents[3].mediaItems.map(
                      (simpleMedia, index) => (
                        <ReactVisibilitySensor partialVisibility key={index}>
                          {({ isVisible }) => (
                            <div
                              className="green-box__item"
                              style={getVisibleSensorAnimation(
                                isVisible,
                                `fade-in-40px 1s ${getDelayedIndexBasedAnimationTime(
                                  windowWidth,
                                  index
                                )}s backwards`
                              )}
                            >
                              {
                                <Media
                                  icon={
                                    businessReviewIcons[3][
                                      simpleMedia.iconIndex
                                    ]
                                  }
                                  SimpleMediaComponent={
                                    <SimpleMedia
                                      counterValue={simpleMedia.counterValue}
                                      prefix={getRightContent(
                                        generalSettings.rtlLanguage,
                                        simpleMedia.prefix || ["", ""]
                                      )}
                                      suffix={getRightContent(
                                        generalSettings.rtlLanguage,
                                        simpleMedia.suffix || ["", ""]
                                      )}
                                      bottomText={getRightContent(
                                        generalSettings.rtlLanguage,
                                        simpleMedia.bottomText
                                      )}
                                    />
                                  }
                                />
                              }
                            </div>
                          )}
                        </ReactVisibilitySensor>
                      )
                    )}
                  </div>
                  <div className="general-separator"></div>
                  <ParagraphImage
                    applyImageClassName={"image-contain "}
                    image={paragraphImages[6]}
                    TextComponent={
                      <>
                        <CustomReadMore
                          text={getRightContent(
                            generalSettings.rtlLanguage,
                            getContent().sections[sections.currentSection]
                              .content.accordionContents[3].customReadMore1.text
                          )}
                          textComplement={getRightContent(
                            generalSettings.rtlLanguage,
                            getContent().sections[sections.currentSection]
                              .content.accordionContents[3].customReadMore1
                              .complement
                          )}
                          applyMainTextClassNameInIndex={{
                            classNames: ["color-primary"],
                            indexes: [0],
                          }}
                        />
                      </>
                    }
                  />
                  <div className="general-separator"></div>
                  <div className="general-separator"></div>
                  <ParagraphImage
                    applyImageClassName={"background-position-right"}
                    image={paragraphImages[7]}
                    imageFirst={true}
                    TextComponent={
                      <>
                        <CustomReadMore
                          text={getRightContent(
                            generalSettings.rtlLanguage,
                            getContent().sections[sections.currentSection]
                              .content.accordionContents[3].customReadMore2.text
                          )}
                          textComplement={getRightContent(
                            generalSettings.rtlLanguage,
                            getContent().sections[sections.currentSection]
                              .content.accordionContents[3].customReadMore2
                              .complement
                          )}
                          applyMainTextClassNameInIndex={{
                            classNames: ["color-secondary"],
                            indexes: [0],
                          }}
                        />
                      </>
                    }
                  />
                  <div className="general-separator"></div>
                  <div className="general-separator"></div>
                  <ParagraphImage
                    applyImageClassName={"image-contain "}
                    image={paragraphImages[8]}
                    TextComponent={
                      <>
                        <CustomReadMore
                          text={getRightContent(
                            generalSettings.rtlLanguage,
                            getContent().sections[sections.currentSection]
                              .content.accordionContents[3].customReadMore3.text
                          )}
                          textComplement={getRightContent(
                            generalSettings.rtlLanguage,
                            getContent().sections[sections.currentSection]
                              .content.accordionContents[3].customReadMore3
                              .complement
                          )}
                          applyMainTextClassNameInIndex={{
                            classNames: ["color-secondary"],
                            indexes: [0],
                          }}
                        />
                      </>
                    }
                  />
                </div>
              ),
            },
          ]}
        />
      </div>
    </div>
  );
}

export default Content8;
